//设置环境(打包前修改此变量)
const ENV = "PROD";
const UNI_APP = {}
if (ENV == "DEV") {
	UNI_APP.BASE_URL = "http://192.168.0.103:8890";
}
if (ENV == "PROD") {
	UNI_APP.BASE_URL = "https://www.shlyszy.com/api/";
}

UNI_APP.URL = "http://127.0.0.1:8080"
UNI_APP.DEFAULT_MEDIAURL_AVATAR = "https://p3.itc.cn/q_70/images03/20231014/c31413eb29914a339ea3bfb58e6f6b73.gif"
UNI_APP.DEFAULT_MEDIAURL_CONTENT_PICURL =
	"https://p3.itc.cn/q_70/images03/20231014/c31413eb29914a339ea3bfb58e6f6b73.gif"
UNI_APP.NICK_NAME = "小乘助手"
UNI_APP.DEFAULT_LOCATION = {
	X: "116.397670219064",
	Y: "39.9429778250342"
}
UNI_APP.ENV = ENV

export default UNI_APP




//push 两次可能是web端跟app端同时登陆